<template>
  <li class="strategio-tree-list-item mt-2">
    <v-card-actions :class="setItemClass (iData.isFolder, iData.hidden)">
      <v-icon
        style="cursor:pointer;"
        v-show="iData.isFolder" 
        color="grey darken-2" 
        @click="toggle()"
      >
        {{open ? 'remove' : 'add'}}
      </v-icon>
      <v-layout column>
        <v-checkbox
          hide-details
          :ripple="false"
          v-model="iData.checked"
          @change="handleChange"
          style="color:#01C0D1 !important;"
          class="strategio-report-checkbox"
          :label="`${iData.itemName} ${iData.hidden ? '(oculto)' : ''}`"
        ></v-checkbox>
        <v-divider></v-divider>

      </v-layout>
    </v-card-actions>
    <ul style="margin-left: 32px" v-if="open">
      <tree-item 
        v-for="(c, $index) in iData.children"
        :i-data="c" 
        :key="$index">
      </tree-item>
    </ul>
  </li>
</template>

<script>
import reportsStorage from '../../storage/reportsStorage'
export default {
  name: 'tree-item',
  props: {
    iData: Object
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    setItemClass (isFolder, isHidden) {
      let q = ''
      if (isFolder) {
        q += 'strategio-tree-folder '
      } else {
        q += 'strategio-tree-item '
      }

      if (isHidden) {
        q += 'strategio-item-hidden'
      }
      return q
    },
    handleChange (checked) {
      this.iData.checked = checked
      reportsStorage.toggleTree(this.iData.children, checked)
    },
    toggle () {
      this.open = !this.open
    }
  }
}
</script>

<style>
.strategio-tree-list-item {
  list-style-type: none;
}

.strategio-folder-toggle {
  cursor: pointer;
}
.strategio-tree-children {
  padding-left: 32px;
}
.strategio-tree-folder {
  padding: 0px !important;
  margin: 0px !important;
}
.strategio-tree-item {
  padding: 0px 0px 0px 32px !important;
  margin: 0px !important;
}
.strategio-item-hidden {
  opacity: 0.5;
}

.strategio-report-checkbox>label {
  font-size: 14px;
  color: grey !important;
}

/* .strategio-checkbox-animation-expansion-enter-active {
  transition: max-height 2s linear;
  max-height: 112px;
  padding: 0;
  overflow: hidden;
}
.strategio-checkbox-animation-expansion-leave-active {
  transition: max-height 2s linear;
  max-height: 0px;
  padding: 0;
  overflow: hidden;
}
.strategio-checkbox-animation-expansion-enter {
  max-height: 0px;
  padding: 0;
  opacity: 0;
}
.strategio-checkbox-animation-expansion-leave {
  max-height: 112px;
  padding: 0;
  opacity: 0;
} */

</style>



// WEBPACK FOOTER //
// src/components/reports/tree-item.vue